import * as React from 'react';
import Flex, { Props as FlexProps } from '../Flex/Flex';
import Icon from '../Icon/Icon';
import './Toggle.css';

export interface Props extends FlexProps {
  /** Sets the toggled state */
  checked?: boolean;
  /** Sets the default toggle state, used when the toggle is not controlled with onChange */
  defaultChecked?: boolean;
  /** Handler for when the toggle state changes */
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
}

/**
 * A slick styled toggle component.
 */
const Toggle: React.FunctionComponent<Props> = (props: Props) => {
  const { checked, children, defaultChecked, onChange, ...rest } = props;

  return (
    <Flex { ...rest }
        Component="label"
        alignChildrenVertical="middle"
        direction="horizontal"
        gap="x2">
      <Flex className="Toggle">
        <input
            checked={ checked }
            className="Toggle__input"
            defaultChecked={ defaultChecked }
            onChange={ onChange }
            type="checkbox" />
        <Flex className="Toggle__control">
          <span className="Toggle__icon-left">
            <Icon name="Tick" />
          </span>

          <span className="Toggle__icon-right">
            <Icon name="CloseSmall" />
          </span>

          <span className="Toggle__knob" />
        </Flex>
      </Flex>

      { children && (
        <Flex>
          { children }
        </Flex>
      ) }
    </Flex>
  );
};

export default Toggle;
